__turbopack_context__.v({
  "heatApp": "_1-ZL2W_heatApp",
  "olandschokladApp": "_1-ZL2W_olandschokladApp",
});
